import { SearchAnesthetists } from 'domain/usecases/search-anesthetists/search-anesthetists'
import { SurgicalScheduleRepository } from 'repository/interfaces/surgical-schedule-repository'

export class RemoteSearchAnesthetists implements SearchAnesthetists {
  constructor(
    private readonly surgicalSchedulingRepository: SurgicalScheduleRepository
  ) {}

  search(params: SearchAnesthetists.Params): Promise<SearchAnesthetists.Model> {
    return this.surgicalSchedulingRepository.searchAnesthetists(params)
  }
}
